export const FIND_REPORT_SUCCESS = 'FIND_REPORT_SUCCESS';

export const findReportSuccess = report => ({
    type: FIND_REPORT_SUCCESS,
    payload: { report },
});
